import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const points = ['Te levantás y lo primero que sentís es incertidumbre: “¿Qué puedo desayunar hoy?”', 'Revisás cada comida con miedo a que algo te dispare la glucosa.', 'Te dieron una lista de prohibidos, pero nadie te explicó qué sí podés comer.', 'Probaste dietas que aguantaste dos días y volviste a empezar de cero.', 'En las reuniones familiares terminás comiendo “aparte” mientras todos disfrutan lo mismo.'];
export function PainPoints() {
  return <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-83" data-mp="220wdeic0kyup">
      <div className="mx-auto max-w-4xl" data-id="element-84" data-mp="1o03ezmildjmb">
        <header className="text-center" data-id="element-85" data-mp="1o1ejxpnrwxf0">
          <h2 className="font-display text-2xl font-bold sm:text-4xl" style={{
          fontSize: "22px"
        }} data-id="element-86" data-mp="1syep7ycstw52">
            ¿Cuánto tiempo más vas a empezar el día con miedo a lo que vas a comer?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-slate-300" data-id="element-87" data-mp="3ncxsw492u5oo">
            Buscás información, te cuidás, no te rendís. Pero hasta ahora nadie te dio un mapa claro para ordenar lo que sí podés hacer desde tu propia cocina.
          </p>
          <p className="mt-4 font-semibold text-brand-light" data-id="element-88" data-mp="1u1btp85y8vxc">
            No es falta de voluntad. Es que te faltaba un sistema.
          </p>
        </header>
        <div className="mt-10 space-y-3" data-id="element-89" data-mp="23r54w826j912">
          {points.map((point, index) => <motion.div key={point} initial={{
          opacity: 0,
          x: -14
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.04,
          duration: 0.26,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-red-900/70 bg-[#250c0c] p-4 sm:p-5" data-id="element-90" data-mp="1g1szzkdvxn4k" data-mpi={index}>
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-91" data-mp="30he3fq3dkepc" />
              <p className="text-sm leading-relaxed text-slate-200 sm:text-base" data-id="element-92" data-mp="2vitfap1edlh9">
                {point}
              </p>
            </motion.div>)}
        </div>
        <p className="mt-12 text-center font-display text-2xl font-bold italic text-brand-gold sm:text-3xl" style={{
        fontSize: "20px"
      }} data-id="element-93" data-mp="1t4vkcjzvwoq9">
          ¿Y si tuvieras un sistema claro para organizar tus comidas desde hoy, sin dejar de disfrutar la mesa?
        </p>
      </div>
    </section>;
}